import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "base-radio" }
const _hoisted_2 = {
  key: 0,
  class: "label"
}
const _hoisted_3 = { class: "options" }
const _hoisted_4 = ["name", "id", "value"]
const _hoisted_5 = ["for"]

import { computed, ref, watchEffect } from "vue";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'base-radio',
  props: {
    id: {},
    options: {},
    width: { default: "100%" },
    value: {}
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "v99209ef0": (_ctx.width)
}))

const { t } = useI18n();

const emit = __emit;

const props = __props;

const internalValue = ref<string | number | null>(null);

function update() {
  emit("update:modelValue", internalValue.value);
  emit("change", internalValue.value);
}

function checkNull(event: Event) {
  if (String(internalValue.value) === String(event.target?.value)) {
    internalValue.value = null;
    update();
  }
}

watchEffect(() => {
  if (props.value) internalValue.value = props.value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$slots.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "label")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "option"
        }, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalValue).value = $event)),
            type: "radio",
            name: __props.id,
            id: `${__props.id}${index}`,
            value: item.value,
            onChange: _cache[1] || (_cache[1] = ($event: any) => (update())),
            onClick: checkNull
          }, null, 40, _hoisted_4), [
            [_vModelRadio, internalValue.value]
          ]),
          _createElementVNode("label", {
            for: `${__props.id}${index}`
          }, _toDisplayString(item.option), 9, _hoisted_5)
        ]))
      }), 128))
    ])
  ]))
}
}

})